//funções auxiliares
export function isPathActive(pathname, item) {
  if (!item) return false;

  if (item.path) return pathname === item.path;

  if (item.submenu?.length) {
    return item.submenu.some((sub) => pathname.startsWith(sub.path));
  }

  return false;
}

export function isInAnySubmenu(pathname, menuItems) {
  return menuItems.some((item) =>
    item.submenu?.some((sub) => pathname.startsWith(sub.path)),
  );
}

export function openExternal(url) {
  window.open(url, "_blank", "noopener,noreferrer");
}
